export default "__VITE_ASSET__CtZTo1lM__"